// extracted by mini-css-extract-plugin
export var item = "screen1top-module--item--a6624";
export var screen1 = "screen1top-module--screen1--c0883";
export var share = "screen1top-module--share--761e9";
export var wrap = "screen1top-module--wrap--edfcd";